import { render, staticRenderFns } from "./Form6.vue?vue&type=template&id=674d424f&scoped=true&"
import script from "./Form6.vue?vue&type=script&lang=ts&"
export * from "./Form6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d424f",
  null
  
)

export default component.exports